// extracted by mini-css-extract-plugin
export default {"subscribe-wrap":"zKTQ5YvBK25oAoNekecL","subscribe-desc":"FUz56BsKpm0wNIIfF34F","subscribe-purple-btn":"w8L0UohDRF1z7NTEd672"};